import {PureComponent} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { uniqBy } from '../../../../../shared/services/lodashInJS.js'
import 'react-select/dist/react-select.css'

import api from '../../../../../api.js'

import './SearchInput.scss'

class SearchInput extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    value: PropTypes.array
  }

  static defaultProps = {
    className: '',
    value: [],
  }

  constructor(props) {
    super(props)
    this.state = {
      values: this.denormValues(props?.value ?? [])
    }

    this.timeoutId = null
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        values: this.denormValues(this.props?.value ?? [])
      })
    }
  }

  normValues(values) {
    return values.map((value) => value.label)
  }

  denormValues(values) {
    return values.map((value) => ({label: value, value}))
  }

  onChange = (values) => {
    return this.props.onChange(this.normValues(values))
  }

  getKeywords = async (search) => {
    if (!search) {
      return ({options: []})
    }

    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }

    return new Promise((resolve) => {
      this.timeoutId = setTimeout(async () => {
        try {
          const result = (await api.keywords.suggest({search, universe: this.props.currentUniverseId})).data
          resolve({
            options: Object.values(result).map((val, index) => ({
              label: val,
              value: index,
            })),
            complete: true,
          })
        } catch (e) {
          console.warn(e)
          resolve({options: []})
        }
      }, 200)
    })
  }

  promptTextCreator = (label) => `Ajouter "${label}"`

  render() {
    return (
      <Select.AsyncCreatable
        key={`${this.props.currentUniverseId}-${this.props.placeholder}`}
        arrowRenderer={null}
        className={`search-bar-input ${this.props.className}`}
        multi={true}
        value={this.state.values}
        onChange={this.onChange}
        loadOptions={this.getKeywords}
        filterOptions={(options) => uniqBy(options, 'label')}
        backspaceRemoves={true}
        ignoreCase={true}
        placeholder={this.props?.placeholder ?? 'Rechercher une compétence ...'}
        searchPromptText="Taper pour chercher"
        noResultsText="Aucun résultat"
        clearValueText="Supprimer toutes les valeurs"
        backspaceToRemoveMessage="Presser retour pour supprimer {last label}"
        promptTextCreator={this.promptTextCreator}
      />
    )
  }
}

export default connect(
  (state) => ({
    currentUniverseId: state?.universe.currentUniverse.id ?? null
  })
)(SearchInput)